import axios from 'axios';
import { urlsServices } from '@/config/urls';
import { getTokenSSO } from '@/utils/index';

export const sendDocumentFileWs = async (file, tipoPermissao, namespace) => {
  if (tipoPermissao === 'TOKEN') {
    return await axios
      .post(`${urlsServices.FILEWS}uploadArquivo`, createDataForm(file, tipoPermissao, namespace), {
        headers: {
          'Content-Type': `multipart/form-data;`,
          token: getTokenSSO(),
        },
      })
      .then((response) => response);
  } else {
    return await axios
      .post(`${urlsServices.FILEWS}uploadArquivo`, createDataForm(file, tipoPermissao, namespace), {
        headers: { 'Content-Type': `multipart/form-data;,`, token: getTokenSSO() },
      })
      .then((response) => response);
  }
};

function createDataForm(file, tipoPermissao, namespace) {
  const formData = new FormData();

  formData.append('arquivo', file);
  formData.append('tipoPermissao', tipoPermissao);
  formData.append('namespace', namespace);

  return formData;
}

export const createArquivoURLPublica = (id) => {
  if (!id) {
    return null;
  }
  return `${urlsServices.FILEWS}/loadArquivo?id=${id}`;
};

export const downloadDocumentFileWs = async (idFileWs, nomeArquivo) => {
  return await axios
    .get(`${urlsServices.FILEWS}loadArquivo`, {
      responseType: 'blob',
      headers: { token: getTokenSSO() },
      params: { id: idFileWs },
    })
    .then((response) => {
      const blobGenerate = new Blob([response.data], { type: response.data.type });
      const downloadURL = window.URL.createObjectURL(blobGenerate);
      const link = document.createElement('a');
      console.log(response.data);
      link.href = downloadURL;
      link.download = nomeArquivo;
      link.click();
    });
};

export const loadDocumentFileWs = async (idFileWs) => {
  return await axios
    .get(`${urlsServices.FILEWS}loadArquivo`, {
      responseType: 'blob',
      headers: { token: getTokenSSO() },
      params: { id: idFileWs },
    })
    .then((response) => {
      return response.data;
    });
};

export const isArquivoValido = (nomeArquivo, extValidos, tamanho, soTamanho = false) => {
  let objReturn = { extensoes: false, tamanho: false };
  if (!soTamanho) {
    if (extValidos.test(nomeArquivo)) {
      objReturn.extensoes = true;
    }
  }

  if (tamanho <= 15000000) {
    objReturn.tamanho = true;
  }
  return objReturn;
};
